var exports = {
  "k": "commentLink__My9dMo",
};

module.exports = exports;
